*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  user-select: none;
  display: inline-block;
}

:host([disabled]) {
  cursor: not-allowed;
  opacity: 0.4;
}

.wui-select-inner {
  position: relative;
  display: flex;
  flex-direction: column;
}

.select-trigger {
  cursor: pointer;

  display: flex;
  gap: 8px;
  align-items: center;

  box-sizing: border-box;
  width: var(--wui-input-width, 200px);
  min-width: var(--wui-control-size, 40px);
  height: var(--wui-control-size, 40px);
  padding: 0 12px;
  border-radius: calc(infinity * 1px);

  &:focus-visible {
    outline: var(--wui-focus-ring-width, 3px) solid var(--wui-color-focus-ring, rgb(0 136 255 / 0.4));
    outline-offset: 2px;
  }
}

.select-trigger[data-custom-trigger] {
  width: auto;
}

:host([disabled]) .select-trigger {
  cursor: not-allowed;
}

.label {
  overflow: hidden;
  flex: 1;

  font-size: var(--wui-font-size, 14px);
  color: var(--wui-color-text, #1b1b1b);
  text-overflow: ellipsis;
  white-space: nowrap;
}

:host(:not([data-has-value])) .label {
  color: var(--wui-color-text-secondary, #6a6a6a);
}

::slotted([slot='trigger']) {
  overflow: hidden;
  flex: 1;

  font-size: var(--wui-font-size, 14px);
  color: var(--wui-color-text, #1b1b1b);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.arrow {
  flex-shrink: 0;
  color: var(--wui-color-text-secondary, #6a6a6a);
}

:host([open]) .arrow {
  transform: rotate(180deg);
}

/* ===== 浮层（glass 样式参考 dialog） ===== */

.select-overlay {
  --wui-internal-glass-shadow: var(--wui-shadow-panel, 0 3px 9px rgb(0 0 0 / 0.27));
  --wui-internal-duration-overlay-enter: var(--wui-duration-menu-enter, 140ms);
  --wui-internal-duration-overlay-exit: var(--wui-duration-menu-exit, 100ms);
  position: absolute;
  z-index: var(--wui-layer-inline-overlay, 1);

  overflow: hidden;

  box-sizing: border-box;
  min-width: var(--wui-overlay-min-width, 200px);
  max-width: var(--wui-select-max-width, 500px);
  border-radius: 20px;

  background-color: var(--wui-color-surface-overlay, rgb(246 246 246 / 0.82));

  &.portal {
    position: fixed;
    z-index: var(--wui-layer-menu, 100);
  }

  &.hidden {
    display: none;
  }
}

.select-scroll {
  overflow-y: auto;
  max-height: 320px;
}

.select-content {
  padding: 4px;
}

:host([portal]) .select-overlay {
  display: none;
}
